import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["profileImage", "profileImageField"]
  declare readonly profileImageTarget: HTMLImageElement
  declare readonly profileImageFieldTarget: HTMLInputElement

  openModal() {
    const modalEl = document.getElementById("profile-upload-modal")
    const modal = Modal.getOrCreateInstance(modalEl)

    const onSave = (event) => {
      const { imageUrl, imageId, orientation } = event.detail

      this.profileImageTarget.src = imageUrl
      this.profileImageFieldTarget.value = imageId

      const ImageInModal = modalEl.querySelector(".modal-content img") as HTMLImageElement
      if (ImageInModal) {
        ImageInModal.src = imageUrl
      }

      modal.hide()
    }

    function onModalHidden() {
      modalEl.removeEventListener("hidden.bs.modal", onModalHidden)
      modalEl.removeEventListener("saveUpload", onSave)
    }

    modalEl.addEventListener("hidden.bs.modal", onModalHidden)
    modalEl.addEventListener("saveUpload", onSave)

    modal.show()
  }
}
